import styled, { css } from 'styled-components'

import prizes from '~/assets/img/thematic-draw_pascoa_2026/prizes.webp'

type ContainerProps = {
  isSelected?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const Container = styled.button<ContainerProps>`
  aspect-ratio: 1/1.10714286;
  background-color: transparent;
  background-repeat: no-repeat;
  background-size: 200% auto;
  border: unset;
  color: inherit;
  cursor: pointer;
  display: block;
  font-family: inherit;
  font-size: 3.6rem;
  padding: unset;
  position: relative;

  &:after {
    background: url(${prizes}) no-repeat;
    background-size: 200% auto;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transition: all 0.2s ease-out;
    width: 100%;
  }

  &:hover::after {
    transform: scale(1.08);
  }

  &:disabled {
    pointer-events: none;
  }

  ${({ isSelected }) => css`
    ${isSelected &&
    css`
      background-image: url(${prizes});

      &::after {
        opacity: 0;
        transform: scale(0.2);
      }
    `}
  `}

  &:nth-child(1) {
    background-position: 100% 0;

    &::after {
      background-position: 0 0;
    }
  }

  &:nth-child(2) {
    background-position: 100% 33.33333%;

    &::after {
      background-position: 0 33.33333%;
    }
  }

  :nth-child(3) {
    background-position: 100% 66.66666%;

    &::after {
      background-position: 0 66.66666%;
    }
  }

  &:nth-child(4) {
    background-position: 100% 100%;

    &::after {
      background-position: 0 100%;
    }
  }
`
